module.exports = __webpack_public_path__ + "fonts/NoirPro-Bold.d9565816.eot";